module.exports = __webpack_public_path__ + "img/rku10-char-2.9904069f.png";